import * as React from 'react'
import { reportActivityError } from './checkout/activity'
export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch(error: Error) { reportActivityError('REACT_RENDER_ERROR', error) }
  render() { return this.state.failed ? <main role="alert" style={{ padding: 32 }}><h1>We couldn’t load your booking</h1><p>Please reload the page to try again.</p><button onClick={() => window.location.reload()}>Reload booking</button></main> : this.props.children }
}
